export default __webpack_public_path__ + "static/media/clock.44d9aa58.svg";